import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from 'react-router-dom';
import '../../../../../../Assets/EnsembleStyles/EnsTenantServicesFeaturebar.css';
import '../../../../../../Assets/EnsembleStyles/ViewTenantDetails.css';
import { setUserIDs} from '../../../../../../action/tenantAction';
import { Button} from 'reactstrap';
import Currencies from  '../../../../../../Resources/Currencies';
import { getAllResources } from '../../../../../../action/cultureAction';

class ViewCompanyInformation extends Component {

  constructor(props){
    super(props);
    this.state = {
      TenantId: this.props.CompanyInformation_response.tenantId,
      TenantName : this.props.CompanyInformation_response.tenantName,
      Address :this.props.CompanyInformation_response.address,
      ContactPhone :this.props.CompanyInformation_response.contactPhone,
      InvoiceEmail :this.props.CompanyInformation_response.invoiceEmail,
      CurrencyId :this.props.CompanyInformation_response.currencyId,
      redirectInvoice: false
    };
    this.PrepareInvoice = this.PrepareInvoice.bind(this);
}

componentDidMount(){
  if(this.props.getLabels["ManageTenants.Create.Text"] === undefined){
    this.props.getAllResources();
  }
}

componentWillReceiveProps(nextProps) {
  if(this.props !== nextProps) {
    this.setState({  
      TenantId : nextProps.CompanyInformation_response.tenantId,
      TenantName : nextProps.CompanyInformation_response.tenantName,
      Address :nextProps.CompanyInformation_response.address,
      ContactPhone :nextProps.CompanyInformation_response.contactPhone,
      InvoiceEmail :nextProps.CompanyInformation_response.invoiceEmail,
      CurrencyId :nextProps.CompanyInformation_response.currencyId,
      });
  }
}

/* Prepare Invoice */

  PrepareInvoice() {
    var Data = { tenantIds: [] };

    Data.tenantIds.push(this.state.TenantId.toString());
    console.log(Data);
    this.props.setUserIDs(Data);

    this.setState({
      redirectInvoice: true
    });
  }

    render(CompanyInformation_response,getLabels,UserCanEdit) {
      let lUserCanEdit;
      let label = this.props.getLabels;

      lUserCanEdit = this.props.UserCanEdit;
      lUserCanEdit = lUserCanEdit !== undefined && lUserCanEdit !== null && lUserCanEdit ? true : false;
        
      if (this.state.redirectInvoice) {
        return <Redirect to={"/Invoices/prepareinvoices"} />
      }
      return (
        <div>
            <div className="buttons_container">
             <Button type="button" hidden={!lUserCanEdit} className="btn btn-black" onClick={ this.props.Display }>{label['ManageTenants.Edit.Text']}  </Button>
             <Button type="button" hidden={!lUserCanEdit} className="btn btn-success" onClick={this.PrepareInvoice} >{label['ManageTenants.BillingPreview.Text']}</Button>
             </div>
          <div className="headinglabel"><p><b>{label['CreateTenant.TenantInformation.Text']}</b></p> </div>
          <div className="viewlabel" ><label className="leftviewlabel">{label['CreateTenant.ViewName.Text']}</label> <label className="rightviewlabel">{this.state.TenantName}</label></div>
          <div className="viewlabel"><label className="leftviewlabel">{label['CreateTenant.Address.Text']}</label> <label className="rightviewlabel">{this.state.Address}</label></div>
          <div className="viewlabel"><label className="leftviewlabel">{label['CreateTenant.InvoiceEmail.Text']}</label> <label className="rightviewlabel">{this.state.InvoiceEmail}</label></div>
          <div className="viewlabel"><label className="leftviewlabel">{label['CreateTenant.ContactInfo.Text']}</label> <label className="rightviewlabel">{this.state.ContactPhone}</label></div>
          <div className="headinglabel"><p><b>{label['CreateTenant.BillingOptions.Text']}</b></p> </div>
          <div className="viewlabel"  ><label className="leftviewlabel">{label['CreateTenant.lblBillingCurrency.Text']}</label> <label className="rightviewlabel">{Currencies.CurrenciesList(this.state.CurrencyId)}</label></div>
         </div>
      );
    }
    }

    const mapStateToProps = state => {
      return {
        CompanyInformation_response: state.ViewtenantsRootReducer.CompanyInformation,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        UserCanEdit: state.authService.HasApplicationFullAcess
      };
    };
    
    const mapDispatchToProps = dispatch => {
      return {
          setUserIDs: (userIDs) => dispatch(setUserIDs(userIDs)),
          getAllResources: () => dispatch(getAllResources()) 
      };
  };
    
    export default connect(mapStateToProps, mapDispatchToProps)(ViewCompanyInformation);




